import { injectToolCSS } from '../utils/cssGenerator'
import { ALL_ELEMENT_SELECTORS } from '../enum/Selectors'
import ToolConfig from '../types/ToolConfig'

export const adjustFontWeightConfig: ToolConfig = {
  id: 'font-weight',
  selector: `html`,
  childrenSelector: ALL_ELEMENT_SELECTORS,
  styles: {
    'font-weight': '700',
  },
}

export default function adjustFontWeight(enable = false) {
  injectToolCSS({
    ...adjustFontWeightConfig,
    enable,
  })
}
